import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useGSAP } from "@gsap/react";
export const SplitUp = () => {
  const location = usePathname();
  gsap.registerPlugin(SplitText);
  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {
    ScrollTrigger.refresh();
    // document.fonts.ready.then(() => {

    gsap.utils.toArray(".split-up").forEach((item, i) => {
      const parentSplit = new SplitText(item, {
        wordsClass: "split-parent",
        type: "words",
      });
      const childSplit = new SplitText(item, {
        type: "words",
        wordsClass: "split-child",
      });

      const tl = gsap.timeline();

      childSplit.words.forEach((i) => {
        i.parentNode.style.height = i.clientHeight + "px";
        i.parentNode.style.overflow = "hidden";
        // i.parentNode.style.background = 'red'
      });

      gsap.from(childSplit.words, {
        duration: 1,
        // delay: .02,
        yPercent: 250,
        ease: "power4.out",
        // stagger: .06,
        scrollTrigger: {
          trigger: item,
          toggleActions: "restart none none reset",
          // start: '-250',
          // start: "top top",
          // end: `+ ${item.clientHeight}`,
          // markers: true
        },
      });
    }); // do stuff

    // })
  }, [location]);
};

export const splitLeft = () => {
  const pathName = usePathname();
  gsap.registerPlugin(SplitText, ScrollTrigger);

  useGSAP(() => {
    gsap.utils.toArray(".split-left").forEach((item, i) => {
      const splitText = new SplitText(item, {
        type: "chars,words,lines",
        reduceWhiteSpace: true,
      });
      const chars = splitText.chars;

      gsap.from(chars, 1.5, {
        x: "10vw",
        // opacity: 0,
        // ease: "elastic.out(1, 0.3)",
        stagger: 0.015,
        scale: 0.95,
        // delay: 0.2,
        ease: "expo.out",
        scrollTrigger: {
          trigger: item,
          toggleActions: "restart none none reset",
        },
      });
      gsap.from(chars, 0.6, {
        // x: 80,
        opacity: 0,
        // ease: "elastic.out(1, 0.3)",
        stagger: 0.016,
        // delay: 0.2,
        ease: "power4.out",
        scrollTrigger: {
          trigger: item,
          toggleActions: "restart none none reset",
        },
      });
    });
  }, [pathName]);
};

export const ParallaxX = () => {
  const pathName = usePathname();
  useGSAP(() => {
    gsap.utils.toArray(".parallax-x").forEach((item, i) => {
      let parallaxSize = item.getAttribute("data-size");
      gsap.to(item, {
        xPercent: parallaxSize || -40,
        ease: "none",
        scrollTrigger: {
          // start: "clump(bottom 0)",
          trigger: item,
          // markers: true,
          scrub: true,
        },
      });
    });
    // return () => {
    //     ScrollTrigger.getAll().forEach(trigger => {
    //         trigger.kill(); // Remove all ScrollTriggers
    //     });
    // };
  }, [pathName]);
};

export const ParallaxXR = () => {
  const pathName = usePathname();
  useGSAP(() => {
    gsap.utils.toArray(".parallax-xr").forEach((item, i) => {
      let parallaxSize = item.getAttribute("data-size");
      gsap.to(item, {
        xPercent: parallaxSize || 30,
        ease: "none",
        scrollTrigger: {
          // start: "clump(bottom 0)",
          trigger: item,
          // markers: true,
          scrub: true,
        },
      });
    });
    // return () => {
    //     ScrollTrigger.getAll().forEach(trigger => {
    //         trigger.kill(); // Remove all ScrollTriggers
    //     });
    // };
  }, [pathName]);
};

// export const FadeUp = () => {
//     const pathName = usePathname();
//     useGSAP(() => {
//         gsap.utils.toArray(".fade-up").forEach((item, i) => {
//             gsap.from(item, {
//                 y: "50px",
//                 ease: "power4.out",
//                 duration: 1,
//                 delay: 0.01,
//                 scrollTrigger: {
//                     // start: "clump(bottom 0)",
//                     trigger: item,
//                     toggleActions: "restart none none reset",
//                 },
//             });
//         });
//         // return () => {
//         //     ScrollTrigger.getAll().forEach(trigger => {
//         //         trigger.kill(); // Remove all ScrollTriggers
//         //     });
//         // };
//     }, [pathName]);
// };

/*---how to use

- add 'split-up' class on the tag like(h1,h2,h3,p ... etc)

*/
